import React from 'react'
import { CloseSVG } from '../../Icons/Basic'
import { MessageConfig, MessageType } from './Message.constants'
import {
  MessageContainer,
  MessageCTAButton,
  MessageCTALink,
  MessageCTARouterLink,
  MessageContent,
  MessageText,
  MessageIcon,
  MessageCloseButton,
} from './Message.styles'
import { MessageCTA } from './Message.types'

export const Message = ({
  messageType,
  messageText,
  ctaButton,
  ctaContent,
  size = 'small',
  padding = '16px',
  onDismiss,
  fullWidth,
}: {
  messageType: MessageType
  messageText: string
  ctaButton?: MessageCTA
  ctaContent?: React.ReactNode
  size?: 'small' | 'medium'
  padding?: string
  onDismiss?: () => void
  fullWidth?: boolean
}): JSX.Element => {
  const { icon, backgroundColor, borderColor } = MessageConfig[messageType]

  const renderCTA = () => {
    if (!ctaButton) return null
    if (ctaButton.to) {
      return (
        <MessageCTARouterLink
          to={ctaButton.to}
          $withMargin={ctaButton.withMargin}
          $size={size}
        >
          {ctaButton.text}
        </MessageCTARouterLink>
      )
    }
    if (ctaButton.href) {
      return (
        <MessageCTALink
          href={ctaButton.href}
          $withMargin={ctaButton.withMargin}
          $size={size}
        >
          {ctaButton.text}
        </MessageCTALink>
      )
    }
    return (
      <MessageCTAButton
        onClick={ctaButton.onClick}
        $withMargin={ctaButton.withMargin}
        $size={size}
      >
        {ctaButton.text}
      </MessageCTAButton>
    )
  }

  return (
    <MessageContainer
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      padding={padding}
      $fullWidth={fullWidth}
    >
      <MessageContent $fullWidth={fullWidth}>
        <MessageIcon $size={size}>{icon}</MessageIcon>
        <MessageText $size={size}>{messageText}</MessageText>
      </MessageContent>
      {ctaContent || renderCTA()}
      {onDismiss && (
        <MessageCloseButton onClick={onDismiss} $size={size}>
          <CloseSVG />
        </MessageCloseButton>
      )}
    </MessageContainer>
  )
}
